<dx-popup #popupAptBooker [width]="840" [minWidth]="840" height="99vh" [maxHeight]="885" [showTitle]="true"
  title="Appointment" [resizeEnabled]=false (onShowing)="onShowing($event)" (onHiding)="onHiding($event)"
  [dragEnabled]="true" [showCloseButton]="true" [fullScreen]="goFullScreen" [hideOnOutsideClick]="false"
  [(visible)]="popupVisible" titleTemplate="titleTemplate" [animation]="null" [wrapperAttr]="{ class: 'apt-booker-popup' }">
  <div *dxTemplate="let data of 'titleTemplate'" class="dlgHeader">
    <div class="dlgHeaderTitle">
      Appointment Booker
    </div>
    <div>
      <dx-button class="headerButton" hint="Reset the appointment booker" icon="revert" [visible]="false"
        (onClick)="btnResetBooker($event)">
      </dx-button>
      <dx-button class="headerButton" hint="Full screen toggle" icon="fullscreen"
        (onClick)="btnFullScreenToggle($event)">
      </dx-button>
      <dx-button class="headerButton" hint="Close the appointment booker" icon="close" (onClick)="btnClose($event)">
      </dx-button>
    </div>
  </div>
  <div *dxTemplate="let data of 'content'" style="overflow-y:scroll;">
    <dx-scroll-view width="100%" height="100%" [direction]="vertical" showScrollbar="always">

      <div *ngIf="bookAptInfo.showClientFinder" style="padding: 10px 5px 0px 10px !important;">
        <app-client-finder #clientFinder (onClientSelected)="onClientSelected($event)"></app-client-finder>
      </div>

      <app-client-info-panel #clientInfo [ClientId]="bookAptInfo.clientId" (onClientEdited)="onClientSelected($event)">
      </app-client-info-panel>

      <app-appointment-time #appointmentTimePanel *ngIf="bookAptInfo.showDateTimePanel" [aptState]="bookAptInfo.State"
        [aptLocked]="bookAptInfo.Locked"
        [aptTime]="bookAptInfo.requestedStartTime" (onDateTimeChanged)="onDateTimeChanged($event)"
        (onAttendAppointment)="onAttendAppointment()" (onCancelAppointment)="onCancelAppointment()"
        [PreSessionDelay]="(client && client.PreSessionDelay ? client.PreSessionDelay:bookAptInfo.PreSessionDelay)" 
        [PostSessionDelay]="(client && client.PostSessionDelay ? client.PostSessionDelay:bookAptInfo.PostSessionDelay)"
        (onUpdateSessionDelays)="onUpdateSessionDelays($event)">
      </app-appointment-time>

      <div class="sessionResource" *ngIf="bookAptInfo.showSessionResourcePanel && isSessionCategoryDataLoaded">
        <div class="sessionPanel" style="flex-basis: 50%; max-width: 50%;width:50%;">
          <app-appointment-session
            #sessionSelection
            [aptState]="bookAptInfo.State"
            [sessions]="sessions"
            [sessionCategories]="sessionCategories"
            [sessionTiles]="sessionTiles"
            [SelectedSession]="bookAptInfo.sessionId"
            (onSessionSelected)="onSessionSelected($event)"
          >
          </app-appointment-session>
        </div>
        <div class="resourcePanel" style="flex-basis: 50%;max-width: 50%; width:50%;">
          <app-appointment-resource #resourceSelection [showLoading]="showResourcesLoading"
            [aptState]="bookAptInfo.State" [resources]="resources" [selectedResource]="bookAptInfo.resourceId"
            [showWarnings]="true" (onResourceSelected)="onResourceSelected($event)">
          </app-appointment-resource>
        </div>
      </div>

      <app-appointment-makesale #makeSale *ngIf="bookAptInfo.showMakeSalePanel" class="makeSale"
        (onSaleMade)="onSaleMade($event)" [selectedClientId]="bookAptInfo.clientId" [aptState]="bookAptInfo.State"
        [bookAptInfo]="bookAptInfo" [allowOverlap]="allowOverlap" [showPaymentAfterSessionBookApt]="showPaymentAfterSessionBookApt" 
        (onBookAppointment)="onBookAppointment($event)">
      </app-appointment-makesale>
      <app-appointment-bookapt #bookapt *ngIf="bookAptInfo.showBookApt"
        [disabled]="!(bookAptInfo.sessionId && bookAptInfo.resourceId)" (onBookAppointment)="onBookAppointment($event)">
      </app-appointment-bookapt>
    </dx-scroll-view>
  </div>
</dx-popup>